module.exports = __webpack_public_path__ + "candidate_dashboard2.jpg?3a15e12b561ca9b25aaffc70b687b786";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/portfoliomanager/candidate_dashboard2.jpg
// module id = 157
// module chunks = 0